import { ModuleType } from '../utils';
import { Constants } from '.';

export const moduleType: ModuleType = {
    type: Constants?.orders?.order
};

export const orderStatusNo = {
    'on-time': 1,
    delay: 2,
    delivered: 3
};

export const parcelGridColumns = [
    {
        id: 1,
        name: Constants?.orders?.gridColumnsTitle?.orderNumber,
        isChecked: true,
        map: 'order_number',
        hasRedirect: true,
        redirectTo: 'track-order',
        method: 'parseParcelOrderNumberCopy'
    },
    {
        id: 2,
        name: Constants?.orders?.gridColumnsTitle?.trackingID,
        isChecked: true,
        map: 'tracking_id',
        method: 'parseTrackingIDRedirect'
    },
    {
        id: 3,
        name: Constants?.orders?.gridColumnsTitle?.parentRetailerName,
        isChecked: true,
        map: 'parent_retailer'
    },
    {
        id: 4,
        name: Constants?.orders?.gridColumnsTitle?.retailerName,
        isChecked: true,
        map: 'retailer'
    },
    {
        id: 4,
        name: Constants?.orders?.gridColumnsTitle?.parcelCode,
        isChecked: true,
        method: 'parseParcelCodeCopy',
        map: 'parcel_code'
    },
    {
        id: 14,
        name: Constants?.orders?.gridColumnsTitle?.postcode,
        isChecked: true,
        method: 'parsePostCodeCopy',
        map: 'postcode'
    },
    {
        id: 5,
        name: Constants?.orders?.gridColumnsTitle?.service,
        isChecked: true,
        map: 'service'
    },
    {
        id: 6,
        name: Constants?.orders?.gridColumnsTitle?.originCountry,
        isChecked: true,
        map: 'senders_country'
    },
    {
        id: 7,
        name: Constants?.orders?.gridColumnsTitle?.destinationCountry,
        isChecked: true,
        map: 'receivers_country'
    },
    {
        id: 8,
        name: Constants?.orders?.gridColumnsTitle?.latestEvent,
        isChecked: true,
        map: 'latest_event'
    },
    {
        id: 9,
        name: Constants?.orders?.gridColumnsTitle?.latestEventDateTime,
        isChecked: true,
        map: 'latest_event_date_and_time',
        method: 'formatMomentDate'
    },
    {
        id: 10,
        name: Constants?.orders?.gridColumnsTitle?.processedDate,
        isChecked: true,
        map: 'date_shipped',
        method: 'formatMomentDate'
    },
    {
        id: 11,
        name: Constants?.orders?.gridColumnsTitle?.deliveryDate,
        isChecked: true,
        map: 'guaranteed_delivery',
        method: 'formatMomentDate'
    }
    // {
    //     id: 12,
    //     name: Constants?.orders?.gridColumnsTitle?.status,
    //     isChecked: true,
    //     map: 'status'
    // }
];

export const parcelGridAllColumns = [
    {
        id: 13,
        name: Constants?.orders?.gridColumnsTitle?.delay,
        isChecked: true,
        map: 'is_delay'
    }
];

export const parcelGridDelayColumns = [
    {
        id: 13,
        name: Constants?.orders?.gridColumnsTitle?.delayedBy,
        isChecked: true,
        map: 'delay_time'
    },
    {
        id: 14,
        name: Constants?.orders?.gridColumnsTitle?.reason,
        isChecked: true,
        map: 'delay_reason'
    },
    {
        id: 15,
        name: Constants?.orders?.gridColumnsTitle?.category,
        isChecked: true,
        map: 'delay_category'
    },
    {
        id: 16,
        name: Constants?.orders?.gridColumnsTitle?.notifiedBy,
        isChecked: true,
        map: 'delay_notified_by'
    },
    {
        id: 17,
        name: Constants?.orders?.gridColumnsTitle?.comment,
        isChecked: true,
        map: 'account_managers_comment',
        method: 'parseAction'
    }
];
